export default "__VITE_ASSET__BDqd8tdK__"